var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spin"},[_c('img',{staticClass:"spin-pan",attrs:{"src":require("../assets/common/spin.png")}})])
}]

export { render, staticRenderFns }